// Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import BlogPost from '../blogPost/blogPost';

// Styles
import BlogPostRelatedPostsStyles from './blogPostRelatedPosts.styles';

export default function BlogPostRelatedPosts({
  relatedPosts,
  heading,
  bgColor,
  flexibleContent,
}) {
  if (!relatedPosts.length) return '';

  return (
    <BlogPostRelatedPostsStyles
      className={`${!flexibleContent && 'spacing-small'}`}
      bgColor={bgColor}
      flexibleContent={flexibleContent}
    >
      <Container>
        <h2 className={`${!!flexibleContent && 'large'}`}>
          {heading || 'Related Articles'}
        </h2>

        <ul className="posts">
          {relatedPosts.map((relatedPost) => (
            <li key={uuid()} className="post">
              <BlogPost post={relatedPost} />
            </li>
          ))}
        </ul>
      </Container>
    </BlogPostRelatedPostsStyles>
  );
}

BlogPostRelatedPosts.propTypes = {
  relatedPosts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  heading: PropTypes.string,
  bgColor: PropTypes.string,
  flexibleContent: PropTypes.bool,
};

BlogPostRelatedPosts.defaultProps = {
  heading: null,
  bgColor: 'white',
  flexibleContent: false,
};
